<p-dialog header="Equipos de impresión" [(visible)]="visible" (visibleChange)="visibleChange.emit($event)"
          (onShow)="onShow()" (onHide)="onHide()" closeAriaLabel="Cerrar equipos de impresión"
          [modal]="true" [dismissableMask]="!pairingLocal && !savingOfficeCode"
          [closable]="!pairingLocal && !savingOfficeCode" [closeOnEscape]="!pairingLocal && !savingOfficeCode"
          [style]="{width: '640px'}" [breakpoints]="{'680px': '95vw'}" appendTo="body">
    <ng-container *ngIf="adding">
        <div class="pc-toolbar">
            <button pButton type="button" icon="pi pi-arrow-left" label="Volver a equipos" class="p-button-text p-button-sm"
                    [disabled]="pairingLocal || savingOfficeCode" (click)="stopAdding()"></button>
        </div>
        <h3 class="pc-add-title">Agregar equipo</h3>
        <div class="pc-add-field">
            <label for="pc-office">Punto de venta que atenderá el equipo de impresión</label>
            <p-dropdown inputId="pc-office" [options]="offices" optionLabel="nombre" optionValue="id" [(ngModel)]="selectedOfficeId"
                        [disabled]="pairingLocal || savingOfficeCode" (onChange)="onOfficeChange()"
                        appendTo="body" styleClass="w-full"></p-dropdown>
            <small>Esta selección configura el equipo de impresión. La sede activa de Teki no cambiará.</small>
            <small *ngIf="officeCode">Código del punto de venta: {{officeCode}}</small>
            <small *ngIf="!offices.length">No tienes puntos de venta disponibles para vincular un equipo.</small>
        </div>
        <form *ngIf="selectedOffice && !officeCode" class="pc-code-box pc-office-code" (ngSubmit)="saveOfficeCode()">
            <p class="pc-code-title">Este punto de venta necesita un código</p>
            <p id="pc-office-code-help" class="pc-hint">
                El código identifica a {{selectedOffice.nombre}} al enviar las impresiones. Defínelo para continuar.
            </p>
            <ng-container *ngIf="canDefineOfficeCode; else officeCodePermission">
                <label for="pc-office-code">Código del punto de venta</label>
                <div class="pc-office-code-actions">
                    <input pInputText id="pc-office-code" name="officeCode" [(ngModel)]="officeCodeDraft" maxlength="50"
                           placeholder="Ej.: SUCURSAL-01" autocomplete="off" [disabled]="savingOfficeCode"
                           [attr.aria-describedby]="officeCodeError ? 'pc-office-code-help pc-office-code-error' : 'pc-office-code-help'"
                           [attr.aria-invalid]="!!officeCodeError" (ngModelChange)="validateOfficeCodeDraft()"/>
                    <button pButton type="submit" [icon]="savingOfficeCode ? 'pi pi-spin pi-spinner' : 'pi pi-check'"
                            [label]="savingOfficeCode ? 'Guardando…' : 'Guardar código'" class="p-button-sm"
                            [disabled]="savingOfficeCode || !validOfficeCodeDraft"></button>
                </div>
                <small>{{officeCodeFormatHint}} Debe ser único en tu empresa.</small>
                <p *ngIf="officeCodeError" id="pc-office-code-error" class="pc-code-error" role="alert">{{officeCodeError}}</p>
            </ng-container>
            <ng-template #officeCodePermission>
                <p>Solicita a un administrador con permiso para editar puntos de venta que defina el código.</p>
            </ng-template>
        </form>
        <ng-container *ngIf="officeCode">
            <p class="pc-code-title" id="pc-location-label">¿Dónde está conectada la impresora?</p>
            <div class="pc-location" role="group" aria-labelledby="pc-location-label">
                <button pButton type="button" label="En esta PC" icon="pi pi-desktop" class="p-button-sm"
                        [class.p-button-outlined]="addMode !== 'local'" [attr.aria-pressed]="addMode === 'local'"
                        [disabled]="pairingLocal || savingOfficeCode" (click)="setAddMode('local')"></button>
                <button pButton type="button" label="En otra PC" icon="pi pi-link" class="p-button-sm"
                        [class.p-button-outlined]="addMode !== 'remote'" [attr.aria-pressed]="addMode === 'remote'"
                        [disabled]="pairingLocal || savingOfficeCode" (click)="setAddMode('remote')"></button>
            </div>
            <ng-container *ngIf="addMode === 'local'">
                <div class="pc-local" role="status" *ngIf="detectingLocal">
                    <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>
                    <span>Buscando el servicio de impresión en esta PC…</span>
                </div>
                <div class="pc-local" *ngIf="!detectingLocal && localClient">
                    <i class="pi pi-desktop" aria-hidden="true"></i>
                    <div class="pc-local-text">
                        <b>{{localClient.deviceName || 'Esta PC'}}</b>
                        <small>Servicio detectado · v{{localClient.version}}</small>
                        <small *ngIf="localClient.paired">
                            Punto de venta actual de este equipo: {{officeName(localClient.officeCode)}}.
                        </small>
                        <small *ngIf="localClientAlreadyPaired">Esta PC ya está vinculada. Puedes agregar otro equipo con un código.</small>
                        <small *ngIf="localClient.paired && localClient.officeCode !== officeCode">
                            Este equipo dejará de atender a {{officeName(localClient.officeCode)}}
                            y atenderá a {{officeName(officeCode)}}.
                        </small>
                    </div>
                    <button *ngIf="!localClientAlreadyPaired" pButton type="button"
                            [icon]="pairingLocal ? 'pi pi-spin pi-spinner' : 'pi pi-link'"
                            [label]="pairingLocal ? 'Vinculando…'
                                : localClient.paired ? 'Cambiar a ' + officeName(officeCode) : 'Vincular esta PC'"
                            class="p-button-sm"
                            [disabled]="!officeCode || pairingLocal" (click)="pairThisComputer()"></button>
                    <button *ngIf="localClient.paired" pButton type="button" icon="pi pi-plus" label="Vincular otro equipo"
                            class="p-button-sm" [class.p-button-outlined]="!localClientAlreadyPaired"
                            [disabled]="pairingLocal || savingOfficeCode" (click)="addAnotherComputer()"></button>
                </div>
                <div class="pc-local" *ngIf="!detectingLocal && !localClient">
                    <div class="pc-local-text">
                        <b>No detectamos el servicio en esta PC</b>
                        <small>Si ya lo instalaste, ábrelo. Después vuelve a buscarlo.</small>
                    </div>
                    <button pButton type="button" icon="pi pi-refresh" label="Volver a buscar" class="p-button-outlined p-button-sm"
                            (click)="detectLocalClient()"></button>
                </div>
                <div class="pc-install" *ngIf="preferredInstaller && !detectingLocal">
                    <div class="pc-local-text">
                        <b>{{localClient ? '¿Necesitas actualizar el servicio?' : '¿Aún no lo instalaste?'}}</b>
                        <small>Descarga y ejecuta el instalador. Si ya está instalado, conserva su configuración.</small>
                    </div>
                    <ng-container *ngTemplateOutlet="installerButton"></ng-container>
                </div>
            </ng-container>
            <ng-container *ngIf="addMode === 'remote'">
                <ol class="pc-steps">
                    <li>En la PC de la impresora, instala y abre el servicio de impresión de {{brand}}.</li>
                    <li>Genera un código aquí. En el servicio, elige <b>Vincular con código</b> e ingrésalo.</li>
                </ol>
                <div class="pc-install" *ngIf="preferredInstaller">
                    <div class="pc-local-text">
                        <b>Instalador del servicio</b>
                        <small>Descárgalo para el sistema de la PC que tiene la impresora.</small>
                    </div>
                    <ng-container *ngTemplateOutlet="installerButton"></ng-container>
                </div>
                <div class="pc-code-box">
                    <p class="pc-code-title">El equipo de impresión atenderá a {{officeName(officeCode)}}</p>
                    <div class="pc-code" *ngIf="pairingCode">
                        <div class="pc-code-row">
                            <span class="pc-code-value">{{pairingCode.code}}</span>
                            <button pButton type="button" class="p-button-text p-button-rounded" aria-label="Copiar código de vinculación"
                                    [icon]="codeCopied ? 'pi pi-check' : 'pi pi-copy'" [disabled]="codeExpired"
                                    [pTooltip]="codeCopied ? 'Copiado' : 'Copiar código'" tooltipPosition="top"
                                    (click)="copyCode()"></button>
                        </div>
                        <small *ngIf="!codeExpired">Un solo uso · vence a las {{pairingCode.expiresAt | date:'HH:mm'}}</small>
                        <small role="status" *ngIf="codeExpired">El código venció. Genera uno nuevo para continuar.</small>
                    </div>
                    <button pButton type="button" [icon]="generating ? 'pi pi-spin pi-spinner' : 'pi pi-key'"
                            class="p-button-outlined p-button-sm"
                            [label]="generating ? 'Generando…' : pairingCode ? 'Generar otro código' : 'Generar código'"
                            [disabled]="!officeCode || generating" (click)="generateCode()"></button>
                </div>
                <div class="pc-pairing-status" *ngIf="pairingCode" aria-live="polite">
                    <p *ngIf="!pairingUpdates.length && !codeExpired">Esperando cambios en los equipos de este punto de venta…</p>
                    <p *ngIf="pairingUpdates.length">Se detectó una vinculación en este punto de venta:
                        <b *ngFor="let device of pairingUpdates; let last = last">
                            {{device.deviceName || 'Equipo sin identificar'}}{{last ? '' : ', '}}</b>.
                        Comprueba que sea el equipo que acabas de vincular.
                    </p>
                    <button pButton type="button" label="Ver equipos vinculados" icon="pi pi-arrow-right" class="p-button-text p-button-sm"
                            (click)="stopAdding()"></button>
                </div>
            </ng-container>
        </ng-container>
    </ng-container>

    <div *ngIf="actionError" class="pc-warn" role="alert">{{actionError}}</div>
    <div class="pc-warn" *ngIf="loadError" role="alert">
        <span>{{loadError}}</span>
        <button pButton type="button" label="Reintentar" class="p-button-text p-button-sm" [disabled]="loading" (click)="load()"></button>
    </div>
    <div class="pc-warn" *ngIf="devicesError && !loadError" role="status">
        <span>No pudimos consultar los equipos vinculados. Los equipos desconectados pueden estar desactualizados o no aparecer.</span>
        <button pButton type="button" label="Reintentar" class="p-button-text p-button-sm" [disabled]="loading" (click)="load()"></button>
    </div>

    <ng-container *ngIf="!adding">
        <div class="pc-toolbar">
            <span class="pc-hint">Equipos de toda la empresa, agrupados por el punto de venta que atienden.</span>
            <span class="pc-toolbar-actions">
                <button pButton type="button" icon="pi pi-plus" label="Agregar equipo" class="p-button-sm" (click)="startAdding()"></button>
                <button pButton type="button" [icon]="loading ? 'pi pi-spin pi-spinner' : 'pi pi-refresh'"
                        class="p-button-text p-button-sm" pTooltip="Actualizar" aria-label="Actualizar equipos de impresión"
                        [disabled]="loading" (click)="load()"></button>
            </span>
        </div>
        <p class="pc-hint" *ngIf="office$ | async as activeOffice">
            El indicador de conexión de la barra superior corresponde a la sede activa de Teki:
            <b>{{activeOffice.nombre || activeOffice.codigo}}</b>.
        </p>
        <p class="pc-hint" role="status" *ngIf="loading && !loaded">Cargando equipos…</p>
        <p class="pc-hint" *ngIf="lastUpdated">Última consulta: {{lastUpdated | date:'HH:mm:ss'}}</p>
        <div class="pc-empty" *ngIf="loaded && !groups.length && !loadError && !devicesError">
            <i class="pi pi-print" aria-hidden="true"></i>
            <p>Aún no hay equipos de impresión</p>
            <small>Agrega la PC que tiene conectada la impresora para empezar.</small>
            <div class="pc-empty-actions">
                <button pButton type="button" icon="pi pi-plus" label="Agregar equipo" class="p-button-sm" (click)="startAdding()"></button>
            </div>
        </div>
        <section class="pc-group" *ngFor="let group of groups">
            <h4 class="pc-group-title">
                <span>{{officeName(group.officeCode)}} <small>· {{group.officeCode}}</small></span>
                <small>{{group.clients.length}} {{group.clients.length === 1 ? 'equipo' : 'equipos'}}</small>
            </h4>
            <div class="pc-warn" *ngIf="group.legacyActive > 1">
                <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
                Hay {{group.legacyActive}} equipos con versión antigua: solo recibe impresiones el que se conectó primero.
                Bloquea los que ya no se usan.
            </div>
            <div class="pc-client" *ngFor="let client of group.clients; trackBy: trackBySocket" [class.is-blocked]="client.blocked">
                <div class="pc-client-main">
                    <i class="pi pi-desktop pc-client-icon" aria-hidden="true"></i>
                    <div class="pc-client-info">
                        <div class="pc-client-name">
                            <span>{{client.deviceName || 'Equipo sin identificar'}}</span>
                            <p-tag [value]="client.connected ? 'Conectado' : 'Desconectado'"
                                   [severity]="client.connected ? 'success' : 'warning'"></p-tag>
                            <p-tag *ngIf="client.isDefault" value="Principal" severity="info"></p-tag>
                            <p-tag *ngIf="client.legacy" value="Versión antigua" severity="warning"></p-tag>
                            <p-tag *ngIf="client.blocked" value="Bloqueado" severity="danger"></p-tag>
                        </div>
                        <small class="pc-client-meta" *ngIf="client.connected">
                            {{client.version ? 'v' + client.version : 'Sin versión'}} · IP {{client.ip || 'no disponible'}}
                            · conectado {{client.connectedAt | date:'dd/MM HH:mm'}}
                        </small>
                        <ng-container *ngIf="!client.connected">
                            <small class="pc-client-meta">Última conexión:
                                {{client.lastSeenAt ? (client.lastSeenAt | date:'dd/MM/yyyy HH:mm') : 'sin registro'}}
                            </small>
                            <small>Abre el servicio de {{brand}} en esta PC y comprueba su conexión a internet.</small>
                        </ng-container>
                        <div class="pc-printers" *ngIf="client.printers?.length">
                            <span class="pc-printer" *ngFor="let printer of client.printers">
                                <i class="pi pi-print" aria-hidden="true"></i>{{printer}}
                            </span>
                        </div>
                        <small *ngIf="client.connected && !client.legacy && !client.printers?.length">
                            No se detectaron impresoras. Comprueba que estén instaladas y encendidas en esa PC.
                        </small>
                        <small class="pc-client-meta" *ngIf="client.legacy && !client.blocked">
                            Esta versión no informa sus impresoras ni acepta acciones remotas. Actualízala para administrarla desde aquí.
                        </small>
                    </div>
                </div>
                <div class="pc-actions" *ngIf="!client.legacy">
                    <button *ngIf="client.connected" pButton type="button" icon="pi pi-print" label="Probar impresión"
                            class="p-button-outlined p-button-sm"
                            [attr.aria-label]="'Probar impresión en ' + (client.deviceName || 'equipo')"
                            [disabled]="!client.printers?.length || !!busySocketId"
                            (click)="openTestMenu(testMenu, $event, client)"></button>
                    <button *ngIf="client.connected || canRemove(client)" pButton type="button" icon="pi pi-ellipsis-h" label="Más opciones"
                            class="p-button-text p-button-sm" [attr.aria-label]="'Más opciones de ' + (client.deviceName || 'equipo')"
                            aria-haspopup="menu" [disabled]="!!busySocketId" (click)="openActionMenu(actionMenu, $event, client)"></button>
                </div>
                <div class="pc-actions" *ngIf="client.legacy && !client.blocked">
                    <button pButton type="button" icon="pi pi-ban" label="Bloquear" class="p-button-outlined p-button-danger p-button-sm"
                            [disabled]="!!busySocketId" (click)="block(client)"></button>
                </div>
            </div>
        </section>
        <p class="pc-hint" *ngIf="groups.length">Principal: equipo de respaldo cuando ningún equipo informa la impresora solicitada.</p>
        <p class="pc-hint" role="status" *ngIf="busySocketId">Aplicando cambio en el equipo…</p>
        <section class="pc-group" *ngIf="blocks.length">
            <h4 class="pc-group-title"><span>Equipos antiguos bloqueados</span></h4>
            <div class="pc-block" *ngFor="let rule of blocks">
                <span>{{officeName(rule.officeCode)}} · {{rule.ip ? 'IP ' + rule.ip : 'cualquier IP'}}
                    · desde {{rule.createdAt | date:'dd/MM/yyyy HH:mm'}}</span>
                <button pButton type="button" label="Desbloquear" class="p-button-text p-button-sm"
                        [disabled]="!!busySocketId" (click)="unblock(rule)"></button>
            </div>
        </section>
    </ng-container>
    <!-- Descarga para el sistema detectado; el desplegable trae los demás -->
    <ng-template #installerButton>
        <p-splitButton [label]="'Descargar para ' + preferredInstaller?.label" icon="pi pi-download"
                       [model]="installerMenu" (onClick)="downloadInstaller(preferredInstaller)"
                       appendTo="body" styleClass="p-button-outlined p-button-sm"></p-splitButton>
    </ng-template>
    <p-menu #testMenu [popup]="true" [model]="testMenuItems" appendTo="body"></p-menu>
    <p-menu #actionMenu [popup]="true" [model]="actionMenuItems" appendTo="body"></p-menu>
</p-dialog>
